import {createAction} from '@reduxjs/toolkit';

export const setSearchFilters = createAction('SET_SEARCH_FILTERS');

export const resetSearchFilters = createAction('RESET_SEARCH_FILTERS');

export const setAccessPermissions = createAction('SET_ACCESS_PERMISSIONS');

export const setSatelliteId = createAction('SET_SATELLITE_ID');

export const setInstruments = createAction('SET_INSTRUMENT');

export const setPublishingStages = createAction('SET_PUBLISHING_STAGES');

export const setSR = createAction('SET_SR');

export const selectImageryCapabilities = createAction(
  'SELECT_IMAGERY_CAPABILITIES'
);

export const setOnlyTasked = createAction('SET_ONLY_TASKED');
